import { Button } from 'components/atoms/Button';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { OnboardingStepWrapper } from 'components/organisms/OnboardingStepLayout';
import type { ActivationStepProps } from '../../types';
import HowIsIntegratedVisual from './HowIsIntegratedVisual';

/**
 * Shows how Accountable Banking integrates with Revenues, Expenses, and Taxes
 * UI-only informational step
 */
const HowIsIntegratedStep: FC<ActivationStepProps> = ({
  onContinue,
  onBack,
  // Wrapper props (automatically injected)
  progressSegments,
  onProgressSegmentClick,
  title,
  subtitle,
  icon,
  showProgressBar,
  isUpdatingStep,
}) => {
  const { t } = useTranslation();

  return (
    <OnboardingStepWrapper
      showProgressBar={showProgressBar}
      progressSegments={progressSegments}
      onProgressSegmentClick={onProgressSegmentClick}
      title={title}
      subtitle={subtitle}
      icon={icon}
      showBackButton
      onBack={onBack}
    >
      <div className="flex items-center justify-center mb-8">
        <HowIsIntegratedVisual />
      </div>

      <Button
        onClick={onContinue}
        className="w-full"
        color="bank"
        disabled={isUpdatingStep}
      >
        {t('continue')}
      </Button>
    </OnboardingStepWrapper>
  );
};

export default HowIsIntegratedStep;
